module.exports = __webpack_public_path__ + "img/client-logo-sky.48000873.png";